module.exports = __webpack_public_path__ + "img/icon_white.f932e20a.png";